import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { UserInfoService } from 'fines-portal/shared/api/data-access/user-info';
import { RouterService } from 'fines-portal/shared/router/data-access/router';
import { catchError, EMPTY, Observable, switchMap, throwError } from 'rxjs';
import { LogService } from 'shared/core/data-access/log';

export const AuthResponseInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const routerService = inject(RouterService);
    const logService = inject(LogService);
    const userInfoService = inject(UserInfoService);

    return next(request).pipe(
        catchError((response: unknown) => {
            if (response instanceof HttpErrorResponse) {
                if (
                    response.status === 401 &&
                    !response.url?.endsWith(userInfoService.userInfoFragment)
                ) {
                    return userInfoService.getUserInfo().pipe(
                        switchMap((userInfo) => {
                            if (userInfo) {
                                logService.log(
                                    'User is logged in -> show error',
                                );
                                return throwError(() => response);
                            } else if (routerService.login().isActive()) {
                                logService.log(
                                    'User is not logged in and already on login page -> show error',
                                );
                                return throwError(() => response);
                            } else {
                                logService.log(
                                    'User is not logged in -> swallow error + redirect to login page',
                                );
                                routerService.login().goTo();
                                return EMPTY;
                            }
                        }),
                    );
                }
            }

            return throwError(() => response);
        }),
    );
};
